<form [formGroup]="form" *ngIf="config && form">
  <div class="form-group">
    <label class="bmd-label-floating" for="partnerId">
      Partner Id
    </label>
    <input
      type="text"
      class="form-control"
      formControlName="partnerId"
      name="partnerId"
      [(ngModel)]="config.partnerId"
    />
  </div>
</form>
